import { createContext } from "react";
export var ConfigContext = createContext(null);